import React from "react";
import bannerImg from "../../assets/images/content-marketing-servivce.png";
import "../../styles/Webdevelopment.css";
import { Link } from "react-router-dom";

function Contentbanner() {
  return (
    <div>
      <section className="webbanner">
        <div className="webbanner-content">
          <h1>Content Marketing Services to Grow Your Business Online</h1>
          <p>
            In these days’s competitive virtual international, corporations need
            greater than only a internet site to prevail. They want precious,
            enticing, and strategic content that attracts, educates, and
            converts their target audience. This is in which professional
           <b> content marketing services</b> play a critical position in
            building logo authority and driving lengthy-term growth.
          </p>
          <div className="webbanner-cta">
            <a href="./Contact" className="webbanner-btn primary">
              Get Free Consultation →
            </a>
          </div>
        </div>
        <div className="webbanner-image">
          <img src={bannerImg} alt="Web Development Solutions" />
        </div>
      </section>
      <div className="breadcrumb">
        <Link to="/">Home</Link>
        <span> / </span>
        <span>content marketing services</span>
      </div>
    </div>
  );
}

export default Contentbanner;
